















































































































































































































































































































































































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";
import Page from "@/components/Page.vue";
import FormSection from "@/components/FormSection.vue";

import store, { PcCodeStore } from "../services/PcCodeStore";
import PcCode, { PcCodeValidationRules } from "../models/PcCode";
import { ValidationRules } from "@/models/Validation";
import { t } from "@/plugins/i18n";

interface Data {
  store: PcCodeStore;
  eventBus: any;
  rules: ValidationRules;
  valid: boolean;
  loading: boolean;
  editedRows: PcCode[];
}

interface Methods {
  updateItem(item: PcCode): void;
  toggleEdit(item: PcCode, edited: boolean): void;
  onMetisModelChange(item: PcCode, selectedModel: any): void;
  onCarCategoryChange(item: PcCode, selectedCategory: any): void;
}

interface Computed {
  columns: ApiSearchColumn[];
  pc3MetModelColumns: ApiSearchColumn[];
  pc4ModelColumns: ApiSearchColumn[];
  pc1url: string;
  pc2url: string;
  pc3MetModelUrl: string;
  pc3ModNameUrl: string;
  pc4url: string;
  pc5url: string;
  pc6url: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    Page,
    ApiSearchPage,
    IconButton,
    FormSection
  },

  async beforeMount() {
    this.loading = true;
    await store.loadMetisModells();
    await store.loadCarCategories();
    this.loading = false;
  },
  
  data() {
    return {
      store,
      eventBus,
      rules: PcCodeValidationRules,
      valid: true,
      loading: false,
      editedRows: [],
    };
  },

  methods: {
    async updateItem(item) {
      this.toggleEdit(item, true);
      await store.updatePcCode(item);
      eventBus.$emit('refreshPcCodes')
    },

    toggleEdit(item, edited) {
      item.inEdit = !item.inEdit;
      if (item.inEdit) {
        this.editedRows.push({...item});
      }
      else {
        if (!edited) {
          const originalItem = this.editedRows.find(i => i.id == item.id);
          if (originalItem) {
            Object.keys(originalItem).forEach(key => {
              if (key !== 'inEdit') {
                this.$set(item as any, key, (originalItem as any)[key]);
              }
            });
          }
        }
        this.editedRows = this.editedRows.filter(i => i.id !== item.id);
      }
    },

    onMetisModelChange(item, selectedModel) {
      item.pcCode = selectedModel.pcCode;
      item.selectedPcCode = selectedModel;
    },

    onCarCategoryChange(item, selectedCategory) {
      item.pcCode6 = selectedCategory.pcCode;
      item.selectedCarCategory = selectedCategory;
    },
  },

  computed: {
    pc1url() {
      return `pc-codes/search/mmgendepot`;
    },
    pc2url() {
      return `pc-codes/search/csshccarbrand`;
    },
    pc3MetModelUrl() {
      return `pc-codes/search/csmetmodell`;
    },
    pc3ModNameUrl() {
      return `pc-codes/search/immetmodell_sercar`;
    },
    pc4url() {
      return `pc-codes/search/csaccinvgroup`;
    },
    pc5url() {
      return `pc-codes/search/csgensalestype`;
    },
    pc6url() {
      return `pc-codes/search/mscarcategory`;
    },
    columns: function() {
      return [
        {
          cell: 'command',
          filterable: false,
          sortable: false,
          width: 110
        },
        {
          field: "valueNational",
          title: t("Ertek"),
        },
        {
          field: "pcCode",
          title: t("PcCode_PCKod"),
          cell: "pcCode",
          width: 300,
          type: ColumnType.Right
        }
      ];
    },
    pc3MetModelColumns: function() {
      return [
        {
          cell: 'command',
          filterable: false,
          sortable: false,
          width: 110
        },
        {
          field: "valueNational",
          title: t("Ertek"),
        },        
        {
          field: "deleted",
          cell: "deleted",
          filterable: false,
          sortable: false,
          title: t("PcCode_Megszunt"),
          width: 90
        },
        {
          field: "pcCode",
          title: t("PcCode_PCKod"),
          cell: "pcCode",
          width: 300,
          type: ColumnType.Right
        }
      ];
    },
    pc4ModelColumns: function() {
      return [
        {
          cell: 'command',
          filterable: false,
          sortable: false,
          width: 110
        },
        {
          field: "valueNational",
          title: t("Ertek"),
        },
        {
          field: "pcCode",
          title: t("PcCode_PCKod"),
          cell: "pcCode",
          width: 300,
          type: ColumnType.Right
        },
        {
          field: "pcCode6",
          cell: "pcCode6",
          title: t("PcCode_TipusPCKod"),
          width: 175,
          type: ColumnType.Right
        },
      ];
    },
  },
});
